import { render } from "./CardInfoMyNote.vue?vue&type=template&id=31e5f450&ts=true"
import script from "./CardInfoMyNote.vue?vue&type=script&lang=ts"
export * from "./CardInfoMyNote.vue?vue&type=script&lang=ts"

import "./CardInfoMyNote.vue?vue&type=style&index=0&id=31e5f450&lang=less"
import "./CardInfoMyNote.vue?vue&type=style&index=1&id=31e5f450&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__